import {
  TrackEventDescriptionApplyT,
  TrackEventReqT,
} from '@consumer-frontend/nc-utils';

import { apiEndpoints } from '../lib/endpoints';
import { getPageViewId, sendBeacon } from '../lib/tracking';

export const trackApplyEvent = (
  eventDescription: TrackEventDescriptionApplyT,
  eventData?: Record<string, unknown>,
): void => {
  const body: TrackEventReqT<TrackEventDescriptionApplyT> = {
    event_data: eventData,
    event_description: eventDescription,
    page_view_id: getPageViewId(),
  };

  sendBeacon(
    apiEndpoints.apply.v2.trackEvent,
    body,
    {
      context: { eventDescription },
      failureMessage: 'sendBeacon failed to queue track_event',
    },
  );
};
